/**
 * PDF player i18n composable (no Vue plugin required)
 */

import { type Ref } from 'vue'
import { currentLocale, setPlayerLocale } from '../../common/locale'
import en from './locales/en.json'
import fr from './locales/fr.json'

export type MessageSchema = typeof en

const messages: Record<string, MessageSchema> = { en, fr }

function resolve(obj: Record<string, any>, path: string): string {
  const keys = path.split('.')
  let current: any = obj
  for (const key of keys) {
    if (current == null || typeof current !== 'object') return path
    current = current[key]
  }
  return typeof current === 'string' ? current : path
}

export interface UsePDFI18nReturn {
  locale: Ref<string>
  t: (key: string, params?: Record<string, string | number>) => string
  setLocale: (locale: string) => void
}

export function usePDFI18n(): UsePDFI18nReturn {
  function t(key: string, params?: Record<string, string | number>): string {
    const lang = currentLocale.value
    let result = resolve(messages[lang] ?? messages.en!, key)

    if (result === key && lang !== 'en') {
      result = resolve(messages.en!, key)
    }

    if (params) {
      for (const [param, value] of Object.entries(params)) {
        result = result.replace(new RegExp(`\\{${param}\\}`, 'g'), String(value))
      }
    }

    return result
  }

  function setLocale(locale: string): void {
    setPlayerLocale(locale)
  }

  return { locale: currentLocale, t, setLocale }
}
